// Simple passthrough template - child routes render in outlet
const PslfLayout = <template>{{outlet}}</template>;

export default PslfLayout;
